import React, { Component } from 'react';
import { Button } from 'antd';
import HOCWorkflow from '../HOCWorkflow';
import ModalScanUpload from './ModalScanUpload';
import ModalArchiveUpload from './ModalArchiveUpload';

class Opration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scanVisible: false,
      archiveVisible: false,
    };
  }

  // 用章-经办人提交扫描件
  handleScanVisible = flag => {
    this.setState({
      scanVisible: !!flag,
    });
  };

  handleSealScan = params => {
    const { data } = this.props;
    this.props.doTask('nextScan', '', { ...params, uuid: data.uuid });
    this.handleScanVisible(false);
  };

  // 用章-行政文件归档
  handleArchiveVisible = flag => {
    this.setState({
      archiveVisible: !!flag,
    });
  };

  handleSealArchive = params => {
    const { data } = this.props;
    this.props.doTask('nextArchive', '', { returns: params, uuid: data.uuid });
    this.handleArchiveVisible(true);
  };

  handleNext = () => {
    const {
      data: {
        instance: { currentActivity },
      },
      doTask,
    } = this.props;

    if (currentActivity.name === '经办人提交扫描件') {
      this.handleScanVisible(true);
    } else if (currentActivity.name === '行政归档') {
      this.handleArchiveVisible(true);
    } else {
      doTask('next');
    }
  };

  render() {
    const { scanVisible, archiveVisible } = this.state;
    const {
      data,
      data: {
        instance: { currentActivity },
      },
      isLoading,
    } = this.props;
    let nextText = '通过';
    if (currentActivity.name === '经办人提交扫描件') {
      nextText = '上传扫描件';
    } else if (currentActivity.name === '行政归档') {
      nextText = '文件归档';
    }

    return (
      <span>
        <Button
          icon="check"
          type="primary"
          onClick={this.handleNext}
          style={{ marginRight: 10 }}
          loading={isLoading || false}
        >
          {nextText}
        </Button>
        <ModalScanUpload
          visible={scanVisible}
          confirmLoading={isLoading || false}
          handleOk={this.handleSealScan}
          handleCancel={this.handleScanVisible}
          effects={data.effects || []}
        />
        <ModalArchiveUpload
          visible={archiveVisible}
          confirmLoading={isLoading || false}
          handleOk={this.handleSealArchive}
          handleCancel={this.handleArchiveVisible}
          effect={data.effects || []}
        />
      </span>
    );
  }
}

export default HOCWorkflow(Opration);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/seal/WorkflowSeal.js